import { internalAxios } from '@/plugins/vueAxios'
import { defineStore } from 'pinia'
import { GalleryPieceRarity } from '@/interfaces/gallery/enums'
// import * from '@/interfaces/responses/gallery/GalleryConverterApiResponse'
import {
  galleryConverterEndpoint as CONVERTER_DATA_ENDPOINT,
  galleryConverterStartEndpoint as CONVERT_START_ENDPOINT,
  galleryConverterSpeedupEndpoint as CONVERT_SPEEDUP_ENDPOINT,
} from '@/globalVariables'
import type {
  ConverterDataResponse,
  Converter,
  ConversionProcess,
  ConvertStartRequestParams,
  ConvertSpeedupRequestParams
} from '@/interfaces/gallery/Converter'
import type { ConversionActionResponse } from '@/interfaces/responses/gallery/GalleryConverterApiResponse'

interface ConverterState {
  converters: Converter[] | null
  processes: ConversionProcess[] | null
}

export const useGalleryConverterStore = defineStore('converter', {
  state: (): ConverterState => ({
    converters: null,
    processes: null,
  }),

  getters: {
  },

  actions: {
    async loadConverterData(): Promise<void> {
      try {
        const data = await internalAxios.get<{}, ConverterDataResponse>(
          CONVERTER_DATA_ENDPOINT,
        )

        if (!data) return

        this.converters = [...data.config]
        this.processes = [...data.operations]
      } catch (error: unknown) {
        console.error(error)
      }
    },

    async startConvert(convert_from: GalleryPieceRarity, convert_from_amount: number): Promise<void> {
      try {
        const response = await internalAxios.post<ConvertStartRequestParams, ConversionActionResponse>(CONVERT_START_ENDPOINT, { convert_from, convert_from_amount })
        this.converters = [...response.config]
        this.processes = [...response.operations]
      } catch (error: unknown) {
        console.error(error)
      }
    },

    async speedupConvert(operation_id: string, type: ConvertSpeedupRequestParams['type']): Promise<void> {
      try {
        const response = await internalAxios.put<ConvertSpeedupRequestParams, ConversionActionResponse>(CONVERT_SPEEDUP_ENDPOINT, { operation_id, type })
        this.converters = [...response.config]
        this.processes = [...response.operations]
      } catch (error: unknown) {
        console.error(error)
      }
    },
  }
})
